export const materialAvailability = `query GetMaterialAvailability($version: String!, $region: String!, $productGroup: String!, $productFamily: String!, $category: String!, $startIndex: Int!, $pageSize: Int!, $sortColumn: String!, $dir: String!, $material: String!) {
  materialAvailability( filter: {
        version: $version,
        region: $region,
        productGroup: $productGroup,
        productFamily: $productFamily,
        category: $category,
        startIndex: $startIndex,
        pageSize: $pageSize,
        sortColumn: $sortColumn,
        dir: $dir,
        material: $material
      }
    ) {
       Materials {
      pkId
      version
      region
      country
      businessGroup
      productGroup
      productFamily
      productDesc
      material
      businessModel
      localization
      choiceId
      startDate
      endDate
      hStartDate
      hEndDate
      comments
      status
      apRegion
      euRegion
      naRegion
      laRegion
      regionLock
      logicalLock
      whoChanged
      createDate
      lastModifiedDate
      keyOrder
      autoStart
      autoEnd
      materialDesc
      countryDesc
    }
    RegionView {
      pkId
      keyOrder
      version
      region
      country
      countryDesc
      businessGroup
      businessModel
      productGroup
      productFamily
      material
      materialDesc
      localization
      choiceId
      wwStartDate
      startDate
      startEndFlag
      endDate
      wwEndDate
      hStartDate
      hEndDate
      comments
      status
      regionLock
      logicalLock
      whoChanged
      createDate
      lastModifiedDate
      p1S
      tof1StartEndFlag
      p1E
      p2S
      tof2StartEndFlag
      p2E
      p3S
      tof3StartEndFlag
      p3E
      p4S
      tof4StartEndFlag
      p4E
      p5S
      tof5StartEndFlag
      p5E
      p6S
      tof6StartEndFlag
      p6E
      p7S
      tof7StartEndFlag
      p7E
      p8S
      tof8StartEndFlag
      p8E
      p9S
      tof9StartEndFlag
      p9E
      p10S
      tof10StartEndFlag
      p10E
      tofWhoChanged
      tofWhenChanged
      errorFlag
      p1SName
      p1EName
      p2SName
      p2EName
      p3SName
      p3EName
      p4SName
      p4EName
      p5SName
      p5EName
      p6SName
      p6EName
      p7SName
      p7EName
      p8SName
      p8EName
      p9SName
      p9EName
      p10SName
      p10EName
      productDesc
      autoStart
      autoEnd
    }
    response
    isError
    count
  }
}`

export const materialBulkDataTransport = `query materialBulkDataTransport($filter: MaterialModuleWiseDTRequest!) {
  materialBulkDataTransport(filter: $filter) {
    response
    message
  }
}`

export const regionalChecklist = `query getRegionalCheckBox($filter: RegionalCheckBoxesRequest!) {
  getRegionalCheckBox(filter: $filter) {
    apRegion
    euRegion
    naRegion
    laRegion
  }
}`